export const action = {
    INSERT: 0,
    REPLACE: 1,
    DELETE: 2,
    ARCHIVE: 3,
};
